var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 20C5.22715 20 0.75 15.5228 0.75 10C0.75 4.47715 5.22715 0 10.75 0C16.2728 0 20.75 4.47715 20.75 10C20.75 15.5228 16.2728 20 10.75 20ZM10.75 18C15.1683 18 18.75 14.4183 18.75 10C18.75 5.58172 15.1683 2 10.75 2C6.33172 2 2.75 5.58172 2.75 10C2.75 14.4183 6.33172 18 10.75 18ZM7.75 7H9.75V13H7.75V7ZM11.75 7H13.75V13H11.75V7Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.96f44b6c9593a753b6a157f03880776a.svg";
export { ForwardRef as ReactComponent };